import React, { Component } from "react";
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface spark {
    options?: ApexOptions,
    width?: string | number,
    height?: string | number,
    series?: ApexOptions['series'],
    [key: string]: any
    label?: XAxisAnnotations
    endingShape?: string
  }

  interface ChartProps {
    data: number[],
    categories: string[]
}

export class ChartBy extends Component<ChartProps, spark> {
  constructor(props: ChartProps) {
    super(props);
  
      this.state = {
  
        series: [{
  
          data: props.data,
          color: '#30CEBF'
        }],
        options: {
          chart: {
            toolbar : {
              show: false,
            },
            height: 225,
            type: 'line',
            width:"100%",
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
  
          grid: {
            borderColor: 'rgba(255,255,255,0.05)',
            row: {
              colors: ['rgba(255,255,255,0.03)', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          xaxis: {
            categories: props.categories,
            axisBorder: {
              show: true,
              color: 'rgba(255,255,255,0.05)',
            },
            axisTicks: {
              show: true,
              color: 'rgba(255,255,255,0.05)',
            }
          },
          tooltip: {
            // color: '#000'
          },
          responsive: [{
            breakpoint: undefined,
            options: {},
        }]
        },
        color: '#000'
      };
    }

    componentDidUpdate(prevProps: ChartProps) {
      // Проверяем, изменились ли пропсы
      if (prevProps.data !== this.props.data || prevProps.categories !== this.props.categories) {
          // Обновляем состояние с новыми данными
          this.setState({
              series: [{
                  data: this.props.data,
                  color: '#30CEBF'
              }],
              options: {
                  ...this.state.options,
                  xaxis: {
                      categories: this.props.categories
                  }
              }
          });
      }
  }


    render() {
      return (
  
        <div id="chart">
  
          <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={350} />
  
        </div>
  
      );
    }
  }
  